module.exports = "pegasus_template/assets/themelp1/charity/101.png";